import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_ORANGE, COLOR_LIGHT_ORANGE } from '../../assets/styles/colors';

export default styled.div`
  padding: 60px 0;
  .modal-loading-wrap {
    display: flex;
    justify-content: center;
  }

  .warning-icon-wrap {
    margin: 0 auto 20px auto;
    height: 80px;
    width: 80px;
    min-width: 80px;
    border-radius: 40px;
    background: ${rgba(COLOR_LIGHT_ORANGE, 0.2)};
    display: flex;
    justify-content: center;
    svg {
      width: 40px;
      height: 40px;
      max-width: 40px;
      margin-top: 20px;
      fill: ${COLOR_ORANGE};
      g {
        stroke: ${COLOR_ORANGE};
        stroke-opacity: 1;
        stroke-width: 5;
      }
    }
  }

  .warning-message-wrap {
    padding: 10px 0;
    text-align: center;
    button {
      margin-left: 5px;
    }
  }

  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
  }
`;
